import { FlawOptionsType } from './types';

export const FLAW_OPTIONS: FlawOptionsType = [
  { id: 'jealous', title: 'A little jealous' },
  { id: 'overthinks', title: 'Overthinks everything' },
  { id: 'flirts_waiter', title: 'Flirts with the waiter' },
  { id: 'rollercoaster', title: 'Emotional rollercoaster' },
  { id: 'ghosted', title: 'Ghosted once, regrets it' },
];
